/* CYBER INNER · reloj de estados, contador, medición, drawer al agregar y brecha del envío gratis. Sin librerías. */
(function () {
  'use strict';
  var C = window.CYBER; if (!C) return;
  var H = document.documentElement;
  var money = function (c) { return window.ihMoney ? window.ihMoney(c) : ('$' + Math.round(c / 100).toLocaleString('es-CL')); };
  var pub = function (name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---- estado por reloj (hora de Santiago fija en -03:00 en octubre; los epochs vienen del servidor) ---- */
  function stateNow() {
    if (!C.on) return 'off';
    var n = Date.now() / 1000, t = C.t;
    if (n >= t.fin) return 'terminado';
    if (n >= t.ultimo) return 'ultimo';
    if (n >= t.evento) return 'evento';
    if (n >= t.anticipado) return 'anticipado';
    return 'previo';
  }
  function target(st) { var t = C.t; return st === 'previo' ? t.anticipado : st === 'anticipado' ? t.evento : (st === 'evento' || st === 'ultimo') ? t.fin : 0; }
  function fmt(secs, st) {
    if (secs <= 0) return '';
    var d = Math.floor(secs / 86400), h = Math.floor((secs % 86400) / 3600), m = Math.floor((secs % 3600) / 60);
    if (st === 'ultimo') return secs > 6 * 3600 ? 'hoy a las 23:59' : 'en ' + (h > 0 ? h + ' h ' : '') + m + ' min';
    if (d > 0) return d + ' d ' + h + ' h';
    if (h > 0) return h + ' h ' + m + ' min';
    return m + ' min';
  }
  function tick() {
    var st = H.dataset.cyberPreview ? H.dataset.cyberState : stateNow();
    if (H.dataset.cyberState !== st) { H.dataset.cyberState = st; }
    H.dataset.cyberEnvio = '0'; /* sin envío gratis */
    var tg = target(st), left = tg ? tg - Date.now() / 1000 : 0, txt = fmt(left, st);
    $$('[data-cy-countdown]').forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
  }
  tick(); setInterval(tick, 30000);

  /* ---- medición ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cy-track]'); if (t) pub(t.dataset.cyTrack, { state: H.dataset.cyberState, label: t.dataset.cyLabel || '' });
  });
  if (H.dataset.cyberAngulo) pub('cyber_angle_view', { angle: H.dataset.cyberAngulo });
  var vipForm = document.querySelector('[data-cy-lista-form]');
  if (vipForm && 'IntersectionObserver' in window) { new IntersectionObserver(function (en, o) { if (en[0].isIntersecting) { pub('vip_form_view', {}); o.disconnect(); } }).observe(vipForm); }

  /* ---- carro: helpers ---- */
  var drawer = function () { return document.querySelector('cart-drawer'); };
  function sections() { var d = drawer(); if (!d || !d.getSectionsToRender) return ''; return d.getSectionsToRender().map(function (s) { return s.id; }).join(','); }
  function cartFetch(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function afterChange(resp) {
    var d = drawer();
    if (d && resp && resp.sections) { d.renderContents(resp); d.classList.toggle('is-empty', !d.querySelector('.cart-item')); d.open(); refresh(); }
    else if (d) { fetch(location.pathname + '?sections=' + sections()).then(function (r) { return r.json(); }).then(function (s) { d.renderContents({ sections: s }); d.classList.toggle('is-empty', !d.querySelector('.cart-item')); d.open(); refresh(); }); }
    else if (document.querySelector('cart-items')) { location.reload(); }
    else { refresh(); }
  }
  function addItems(items, extra) { return cartFetch('/cart/add.js', { items: items, sections: sections() }).then(function (r) { afterChange(r); return r; }); }
  function updates(map) { return cartFetch('/cart/update.js', { updates: map, sections: sections() }).then(function (r) { afterChange(r); return r; }); }

  /* ---- agregar al carro desde el buybox propio: abre el drawer en vez de recargar ---- */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.classList || !f.classList.contains('ih-bb__form') || !drawer()) return;
    e.preventDefault();
    var fd = new FormData(f); var id = fd.get('id'); if (!id) { f.submit(); return; }
    var item = { id: parseInt(id, 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    var sp = fd.get('selling_plan'); if (sp) item.selling_plan = parseInt(sp, 10);
    addItems([item]).then(function () { var b = f.querySelector('[name=add]'); if (b) { b.removeAttribute('aria-busy'); var t = b.querySelector('.ih-bb__cta-t'); if (t) t.textContent = b.dataset.label || 'Agregar al carro'; } pub('bundle_compare_add', { variant: item.id, from: 'pdp' }); }).catch(function () { f.submit(); });
  }, true);

  /* ---- brecha del envío gratis ---- */
  var offer = function () { return H.dataset.cyberEnvio === '1'; };
  var reachedSent = false;
  function thresholdFor(cart) {
    var hasCode = (cart.discount_codes && cart.discount_codes.some(function (c) { return c.applicable; })) || (cart.total_discount > 0);
    return hasCode ? C.umbralCodigo : C.umbral;
  }
  function inCart(cart, vid) { return cart.items.filter(function (i) { return i.variant_id === vid; }); }
  function suggestions(cart, falta) {
    var out = [];
    if (C.main) {
      var packs = C.main.variants.filter(function (v) { return v.available && v.units > 1; }).sort(function (a, b) { return a.units - b.units; });
      var single = C.main.variants.filter(function (v) { return v.units === 1; })[0];
      var line = single ? inCart(cart, single.id)[0] : null;
      if (line && line.quantity === 1 && packs.length) {
        packs.forEach(function (p) {
          if (out.length >= 2) return;
          var diff = p.price - single.price, total = cart.total_price - single.price + p.price;
          out.push({ kind: 'swap', from: single.id, to: p.id, title: C.main.title, sub: p.title + ' · ' + money(Math.round(p.price / p.units)) + ' por frasco' + (total >= C.umbral ? ' · llega a envío gratis' : ''), price: diff, img: C.main.img, btn: 'Cambiar por +' + money(diff) });
        });
        return out;
      }
    }
    if (falta <= 0 || falta > C.brechaMax) return out;
    var cands = C.sug.filter(function (s) { return !inCart(cart, s.id).length; });
    var cross = cands.filter(function (s) { return s.price >= falta; }).sort(function (a, b) { return a.price - b.price; });
    var list = cross.length ? cross : cands.sort(function (a, b) { return b.price - a.price; });
    list.slice(0, 2).forEach(function (s) { out.push({ kind: 'add', to: s.id, title: s.title, sub: money(s.price) + ' · Cyber' + (s.goal ? ' · ' + s.goal : ''), img: s.img, btn: 'Agregar' }); });
    return out;
  }
  function render(cart) {
    var boxes = $$('[data-cy-gap]'); if (!boxes.length) return;
    var show = offer() && C.umbral > 0 && cart.item_count > 0;
    boxes.forEach(function (box) {
      if (!show) { box.hidden = true; return; }
      box.hidden = false;
      var thr = thresholdFor(cart), total = cart.total_price, falta = thr - total, pct = Math.min(100, Math.round(total * 100 / thr));
      var t = box.querySelector('.cy-gap__t'), bar = box.querySelector('.cy-gap__bar i'), hint = box.querySelector('.cy-gap__hint'), list = box.querySelector('.cy-gap__list'), ship = box.querySelector('.cy-gap__ship span:last-child');
      if (bar) bar.style.width = pct + '%';
      if (falta <= 0) {
        if (t) { t.className = 'cy-gap__t is-ok'; t.textContent = '✓ ' + C.txt.listo; }
        if (hint) hint.hidden = true; if (list) list.innerHTML = '';
        if (ship) ship.textContent = 'gratis';
        if (!reachedSent) { reachedSent = true; pub('free_shipping_reached', { total: total }); }
        return;
      }
      if (t) { t.className = 'cy-gap__t'; t.innerHTML = C.txt.falta + ' <b>' + money(falta) + '</b> para el envío gratis'; }
      if (ship) ship.textContent = 'desde ' + money(C.shipMin || 399000) + ' según zona';
      var sug = suggestions(cart, falta);
      if (hint) { hint.hidden = !sug.length; hint.textContent = sug[0] && sug[0].kind === 'swap' ? 'Cambia tu frasco por un pack y paga menos por frasco:' : C.txt.sug + ' ($3.990 a $6.500):'; }
      if (list) {
        list.innerHTML = sug.map(function (s, i) {
          return '<div class="cy-gap__sug"><img src="' + s.img + '" alt="" loading="lazy"><div><div class="n">' + s.title + '</div><div class="d">' + s.sub + '</div></div><button type="button" data-cy-sug="' + i + '">' + s.btn + '</button></div>';
        }).join('');
        list._sug = sug;
        if (sug.length) pub('cart_upsell_view', { kinds: sug.map(function (s) { return s.kind; }).join(',') });
      }
    });
  }
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { window.__cyCart = c; render(c); }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cy-sug]'); if (!b) return;
    var list = b.closest('.cy-gap__list'), s = list && list._sug && list._sug[+b.dataset.cySug]; if (!s) return;
    b.setAttribute('aria-busy', 'true'); pub('cart_upsell_accept', { kind: s.kind, variant: s.to });
    var p = s.kind === 'swap' ? (function () { var m = {}; m[s.from] = 0; m[s.to] = 1; return updates(m); })() : addItems([{ id: s.to, quantity: 1 }]);
    p.catch(function () { b.removeAttribute('aria-busy'); });
  });
  var _fetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0], url = (a && a.url) || a || '', p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refresh, 80); }).catch(function () {});
    return p;
  };
  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();

  /* ---- agregar de un toque desde la landing (comparador) ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cy-add]'); if (!b || b.disabled) return;
    b.setAttribute('aria-busy', 'true'); var id = parseInt(b.dataset.cyAdd, 10);
    pub('bundle_compare_add', { variant: id, from: 'landing', label: b.dataset.cyLabel || '' });
    addItems([{ id: id, quantity: 1 }]).then(function () { b.removeAttribute('aria-busy'); }).catch(function () { b.removeAttribute('aria-busy'); location.href = '/cart/add?id=' + id + '&quantity=1'; });
  });
  window.Cyber = { refresh: refresh, add: addItems, state: stateNow };
})();
